import React, {useState} from "react";
import styled from "styled-components";

const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const SelectWrapper = styled.div`
    display: flex;
    gap: 10px; 
    @media (max-width: 767px) {
        width: 90%;
        justify-content: space-between;
  }
`;

const Select = styled.select`
    width: 200px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

const Button = styled.button`
    display: flex;
    padding: 5px 10px;
`;

const AgendaFilter = ({ scheduleData, setRoom, setTime, setCategory }) => {

    const [roomValue, setRoomValue] = useState("");
    const [timeValue, setTimeValue] = useState("");
    const [categoryValue, setCategoryValue] = useState("");

    // only show unique categories
    const categories = [...new Set(scheduleData.events.map((event) => event.type))];

    const handleRoom = (e) => {
        const value = e.target.value;
        setRoomValue(value);
        setRoom(value || null);
      };
    
      const handleTime = (e) => {
        const value = e.target.value;
        setTimeValue(value);
        setTime(value || null);
      };
    
      const handleCategory = (e) => {
        const value = e.target.value;
        setCategoryValue(value);
        setCategory(value || null);
      };
    
      const resetFilters = () => {
        setRoomValue("");
        setTimeValue("");
        setCategoryValue("");
        setRoom(null);
        setTime(null);
        setCategory(null);
      };

    return (
        <>
            <FilterWrapper>
                <SelectWrapper>
                    <label htmlFor="room-filter">Rom:</label>
                    <Select value={roomValue} id="room-filter" onChange={handleRoom}>
                        <option value="" key={'all-rooms'}>
                            Alle
                        </option>
                        {scheduleData.tracks.map((track) => (
                            <option key={track.id} value={track.id}>
                                {track.name}
                            </option>
                        ))}
                    </Select>
                </SelectWrapper>
                
                <SelectWrapper>
                    <label htmlFor="time-filter">Tid:</label>
                    <Select value={timeValue} id="time-filter" onChange={handleTime}>
                        <option value="" key={'all-times'}>
                            Alle
                        </option>
                        {scheduleData.slots.map((slot) => (
                            <option key={slot.id} value={slot.id}>
                                {slot.label}
                            </option>
                        ))}
                    </Select>
                </SelectWrapper>

                <SelectWrapper>
                    <label htmlFor="category-filter">Kategori:</label>
                    <Select value={categoryValue} id="category-filter" onChange={handleCategory}>
                        <option value="" key={'all-categories'}>
                            Alle
                        </option>
                        {categories.map((category) => (
                            <option key={category} value={category}>
                                {category}
                            </option>
                        ))}
                    </Select>
                </SelectWrapper>
            </FilterWrapper>
            <ButtonWrapper>
                <Button onClick={resetFilters}>nullstill filter</Button>
            </ButtonWrapper>
        </>
    );
};

export default AgendaFilter;
